
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { useAdminSettings } from '@/hooks/useAdminSettings';
import ReferralUsersTable from '@/components/admin/ReferralUsersTable';
import SearchReferralUsers from '@/components/admin/SearchReferralUsers';
import { useReferralUsers } from '@/hooks/useReferralUsers';
import ReferralUsersLoading from '@/components/admin/ReferralUsersLoading';
import ReferralUsersActions from '@/components/admin/ReferralUsersActions';

const AdminReferralUsers = () => {
  const { user, handleLogout } = useAdminSettings();
  const { 
    users,
    isLoading, 
    searchTerm, 
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    approveUser,
    rejectUser,
    deleteUser
  } = useReferralUsers();
  
  // Add these functions to make the component compatible with expected props
  const handleRefresh = () => {
    console.log('Refreshing referral users data');
    // In a real app, this would refetch the data
  };
  
  const handleExportCSV = () => {
    console.log('Exporting referral users to CSV');
    // In a real app, this would download a CSV file
    alert('CSV Export functionality would download a file here');
  };

  return (
    <AdminLayout isLoading={false} userRole={user?.role} onLogout={handleLogout}>
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold">Referral Users</h1>
          <ReferralUsersActions
            onRefresh={handleRefresh}
            onExportCSV={handleExportCSV}
            isLoading={isLoading}
          />
        </div>
        
        <div className="mb-4">
          <SearchReferralUsers
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
          />
        </div>
        
        {isLoading ? (
          <ReferralUsersLoading />
        ) : (
          <ReferralUsersTable
            users={users}
            onApprove={approveUser}
            onReject={rejectUser}
            onDelete={deleteUser}
          />
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminReferralUsers;
